





























































































































































































































































































































































































































































































































































































import PowerConditionerDialog from "@/components/dialog/powerConditioner.vue";
import MeterDataSendDialog from "@/components/dialog/meterDataSendDialog.vue";
import UploadScheduleDialog from "@/components/dialog/uploadScheduleDialog.vue";
import LineChart from "@/components/chart/LineChart.vue";
import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import xlsx from "xlsx";
import {
  meters,
  childMeters,
  queryMeter,
  QueryMeterReq,
  updateMeter,
  setParentMeter,
  SetMeterParentReq,
  SearchMeterReq,
  GetMetersReq,
  SendDataReq,
  sendData,
  meterTypes,
  BatchBindMeterCostReq,
  BatchBindUserReq,
  batchBindMeterCost,
  batchBindUser,
  deleteMeter,
  DeleteMeterReq,
  MeterTypeReq,
  meterDetail,
  GetMeterDetailReq,
} from "@/api/meter";
import { RouteConfig } from "vue-router";
import {
  ResCode,
  PagingReq,
  Meter,
  User,
  MeterCost,
  Company,
  Address,
  MeterType,
  Fireware,
} from "@/api/baseDefine";
import { queryMeterCost, meterCosts, GetMeterCostReq } from "@/api/meterCost";
import { formatDate } from "@/utils/dateUtil";
import { ElTree, TreeData } from "element-ui/types/tree";
import { UserModule } from "@/store/modules/user";
import { ElStep } from "element-ui/types/step";
import { queryUser, QueryUserReq } from "../../api/user";
import { getAddresses, GetAddress } from "../../api/address";
import { GetMeterReq, getMeterData, History } from "../../api/home";
import MeterEditDialog from "@/components/dialog/meterEditDialog.vue";
import { QueryMeterCostReq } from "../../api/meterCost";
import { Getter } from "vuex";
import { CompanyCommonReq, geCompanys } from "@/api/company";
import { FirewareCommonReq, geFirewares } from "@/api/fireware";

/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({
  components: {
    Pagination,
    LineChart,
    PowerConditionerDialog,
    MeterDataSendDialog,
    UploadScheduleDialog,
    MeterEditDialog,
  },
})
export default class Network extends Vue {
  private time = "";
  private meterTypes: string[] = [];

  private mqttTypes = ["normal", "tsl", "aws"];
  private disableStates: {
    index: number;
    state: string;
  }[] = [];
  private dialogBatch = false;

  private dialogEditMeter = false;
  private dialogBatchWrite = false;
  private dialogPowerConditioner = false;
  private isSearch = false;
  private editMeter: Meter = <Meter>{};

  private queryMeterTypes: MeterType[] = [];
  private queryCompanys: Company[] = [];

  private queryUsers: User[] = [];
  private queryInstallUsers: User[] = [];
  private queryMeters: Meter[] = [];
  private queryMeterCosts: MeterCost[] = [];
  private addressSearchType = 1;
  private queryAddresses: Address[] = [];

  private queryProviceList: string[] = [];
  private queryCityList: string[] = [];
  private queryStreetList: string[] = [];

  private searchMeter: Meter = <Meter>{};
  private loading: boolean = false;

  private list: Meter[] = [];
  private listLoading: boolean = true;

  private dialogType = "edit"; //判断弹出层是添加还是编辑
  private total = 0;
  private parentMeter: string = "";
  private roleKey = "";

  private batchParentMeterID = "";
  private batchBindUserID = "";
  private batchBindMeterCostName = "";
  private batchBindNextCostName = "";
  private batchBindNextCostDate = "";
  private selectItems = new Array<Meter>();

  private adminID = 0;

  private listQuery: GetMetersReq = <GetMetersReq>{
    page: 1,
    pageSize: 10,
  };

  private showBatch = false;
  public onSelectOwnUser(b) {
    if (b) {
      this.queryOwnUser("");
    }
  }
  public onSelectInstallUser(b) {
    if (b) {
      this.queryInstallUser("");
    }
  }

  public onSelectCompany(b) {
    if (b) {
      this.queryCompany("");
    }
  }

  public onSelectParentMeterID(b) {
    if (b) {
      this.queryMeter("");
    }
  }

  public onSelectChangeProvince(b) {
    if (b) {
      this.addressSearchType = 2;
      this.queryAddress("");
    }
  }

  public onSelectChangeCity(b) {
    if (b) {
      this.addressSearchType = 3;
      this.queryAddress("");
    }
  }
  public onSelectChangeDetail(b) {
    if (b) {
      this.addressSearchType = 4;
      this.queryAddress("");
    }
  }

  public onSelectMeterCost(b) {
    if (b) {
      this.queryMeterCost("");
    }
  }

  public async queryMeter(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await meters(<GetMetersReq>{ meter: { meterID: query } });
      if (res.code === ResCode.SUCCESS) {
        this.queryMeters = res.data.meters.list;
        this.loading = false;
      }
    }
  }

  public async queryMeterType() {
    this.loading = true;
    const res = await meterTypes(<MeterTypeReq>{});
    if (res.code === ResCode.SUCCESS) {
      this.queryMeterTypes = res.data.meterTypes.list;
      for (let type of this.queryMeterTypes) {
        type.name = this.meterTypes[type.id - 1];
      }
      this.loading = false;
    }
  }
  public async queryMeterCost(query: string) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await meterCosts(<GetMeterCostReq>{
        page: 1,
        pageSize: 10,
        name: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryMeterCosts = res.data.meterCostData.list;
        this.loading = false;
      }
    }
  }
  public async queryOwnUser(query) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryUser(<QueryUserReq>{
        queryUserType: 0,
        query: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }

  public async queryAddress(query: string) {
    let req: GetAddress = <GetAddress>{};
    let address: Address = <Address>{};
    req.page = 1;
    req.pageSize = 10;
    req.address = address;
    req.searchType = this.addressSearchType;
    this.loading = true;
    address.country = query;
    address.province = query;
    address.city = query;
    address.detail = query;
    const res = await getAddresses(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryAddresses = res.data.addressesData.list;
      this.queryProviceList = [];
      this.queryCityList = [];
      this.queryStreetList = [];
      for (let address of this.queryAddresses) {
        if (this.queryProviceList.indexOf(address.province) < 0) {
          this.queryProviceList.push(address.province);
        }
        if (this.queryCityList.indexOf(address.city) < 0) {
          if (
            !this.searchMeter.province ||
            address.province == this.searchMeter.province
          ) {
            this.queryCityList.push(address.city);
          }
        }
        if (this.queryStreetList.indexOf(address.detail) < 0) {
          if (!this.searchMeter.city || address.city == this.searchMeter.city) {
            this.queryStreetList.push(address.detail);
          }
        }
      }
      this.loading = false;
    }
  }

  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }

  public async queryInstallUser(query) {
    if (query !== null && query !== undefined) {
      this.loading = true;
      const res = await queryUser(<QueryUserReq>{
        queryUserType: 1,
        query: query,
      });
      if (res.code === ResCode.SUCCESS) {
        this.queryInstallUsers = res.data.users.list;
        this.loading = false;
      }
    }
  }

  public loadChild(tree, treeNode, resolve) {
    childMeters({ meterID: tree.id }).then((res) => {
      let childs: Meter[] = res.data.meters.list;
      resolve(childs);
    });
  }

  public async getList() {
    let req = <GetMetersReq>{
      page: this.listQuery.page,
      pageSize: this.listQuery.pageSize,
    };
    if (this.isSearch) {
      req.meter = this.searchMeter;
    }
    const res = await meters(req);
    if (res.code === ResCode.SUCCESS) {
      this.roleKey = "";
      this.list = res.data.meters.list;
      this.total = res.data.meters.totalCount;
    }
    this.listLoading = false;
  }

  public async getDetailMeter(id: number) {
    let req = <GetMeterDetailReq>{};
    req.id = id;
    let meterRes = await meterDetail(req);
    if (meterRes.code == ResCode.SUCCESS && !!meterRes.data.meter) {
      this.editMeter = meterRes.data.meter;
    }
  }

  public async searchMeters() {
    this.isSearch = true;
    this.listQuery.page = 1;
    this.getList();
  }

  public async exportExecl() {
    let json = await this.getAllData();
    let ss = xlsx.utils.json_to_sheet(json, null); //通过工具将json转表对象
    let keys = Object.keys(ss).sort(); //排序 [需要注意，必须从A1开始]
    let ref = keys[1] + ":" + keys[keys.length - 1]; //这个是定义一个字符串 也就是表的范围[A1:C5]
    let workbook = {
      //定义操作文档
      SheetNames: ["nodejs-sheetname"], //定义表明
      Sheets: {
        "nodejs-sheetname": ss, //表对象[注意表明]
      },
    };
    xlsx.writeFile(workbook, "./suzhenwei.xls", null); //将数据写入文件
  }
  public async getAllData(): Promise<Meter[]> {
    let pageSize = 100;
    let page = 1;
    let reqs: GetMetersReq[] = [];
    let promises: Promise<Meter[]>[] = [];
    let maxPage = Math.ceil(this.total / pageSize);
    let lists: Meter[] = [];
    while (maxPage - page >= 0) {
      let req: GetMetersReq = <GetMetersReq>{};
      req.page = page;
      req.pageSize = pageSize;
      let promise = this.getListForAllData(req);
      promises.push(promise);
      page++;
    }
    let listss = await Promise.all(promises);
    for (let list of listss) {
      lists = lists.concat(list);
    }
    return lists;
  }

  public async getListForAllData(req: GetMetersReq): Promise<Meter[]> {
    let self = this;
    return new Promise<Meter[]>(function (value, rej) {
      if (self.isSearch) {
        req.meter = self.searchMeter;
      }
      meters(req)
        .then(function (res) {
          if (!!res && res.code === ResCode.SUCCESS) {
            let list = res.data.meters.list;
            value(list);
          }
        })
        .catch(function (reason) {
          rej(reason);
        });
    });
  }

  public async clickEditMeter(scope) {
    this.editMeter = Object.assign({}, scope.row);
    await this.getDetailMeter(this.editMeter.id);
    this.dialogEditMeter = true;
    this.queryMeterCosts = [];
    this.queryUsers = [];
    this.queryInstallUsers = [];
    this.queryMeters = [];
    let meterEditDialogRef = this.$refs.meterEditDialogRef as any;
    meterEditDialogRef.clickShow(this.editMeter);
  }

  public async clickUploadSchedule(scope){
    let uploadScheduleRef = this.$refs.uploadScheduleRef as any;
     uploadScheduleRef.clickShow(this.selectItems);
  }

  private dialogDelete = false;
  public clickDelete(scope) {
    this.editMeter = Object.assign({}, scope.row);
    this.dialogDelete = true;
  }
  private deleteType = 0;
  public async deleteMeter() {
    const res = await deleteMeter(<DeleteMeterReq>{
      meterID: this.editMeter.meterID,
      deleteType: this.deleteType,
    });
    if (!!res && res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message:
          this.editMeter.deleteState === 0
            ? this.$t("notification.DisableMeterSuccess").toString()
            : this.$t("notification.EnableMeterSuccess").toString(),
        type: "success",
      });
      this.getList();
      this.dialogDelete = false;
    }
  }

  public clickBatchWrite() {
    let meterDataSendRef = this.$refs.meterDataSendRef as any;
    meterDataSendRef.clickShow(this.selectItems);
  }

  public clickPowerConditioner() {
    let powerConditionerRef = this.$refs.powerConditionerRef as any;
    powerConditionerRef.clickShow();
    this.dialogPowerConditioner = true;
  }

  public async handleEditMeter() {
    console.log(this.editMeter);
    if (!!this.editMeter.installDate) {
      this.editMeter.installDate = formatDate(
        new Date(this.editMeter.installDate)
      );
    }
    if (!!this.editMeter.expireDate) {
      this.editMeter.expireDate = formatDate(
        new Date(this.editMeter.expireDate)
      );
    }

    if (!!this.editMeter.nextMeterCostDate) {
      let date = new Date(this.editMeter.nextMeterCostDate);
      if (
        date.getDate() !== UserModule.companyPaymentDate ||
        date.getTime() < Date.now()
      ) {
        this.$notify({
          title: this.$t("common.warning").toString(),
          message: this.$t("notification.MeterCostDateError").toString(),
          type: "warning",
        });
        return;
      }
      this.editMeter.nextMeterCostDate = formatDate(
        new Date(this.editMeter.nextMeterCostDate)
      );
    }
    const res = await updateMeter(this.editMeter);
    if (res.code === ResCode.SUCCESS) {
      this.dialogEditMeter = false;
      this.getList();
    }
  }

  public handleSelectionChange(val) {
    this.selectItems = val;
    if (!!this.selectItems && this.selectItems.length > 0) {
      this.showBatch = true;
    } else {
      this.showBatch = false;
    }
  }

  public async clickReset() {
    this.searchMeter = <Meter>{};
  }
  public handleClickBatch(scope) {
    this.parentMeter = "";
    this.dialogBatch = true;
    this.batchSet = false;
  }
  public closeBatchDialog() {
    if (this.batchSet) {
      this.getList();
    }
  }

  private onReadPowerLineValueChange(b) {
    console.log("onReadPowerLineValueChange", b);
  }
  private batchSet = false;
  // 批量设置表的上级
  public async batchSetMeterParent() {
    let req: SetMeterParentReq = <SetMeterParentReq>{};
    let meterIDS: number[] = [];
    for (let item of this.selectItems) {
      if (!meterIDS.includes(item.id)) {
        meterIDS.push(item.id);
      }
    }
    req.batchMeterIDs = meterIDS;
    req.baseMeterIDStr = this.batchParentMeterID;
    if (!this.batchParentMeterID) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("notification.PleaseSelectMeterID").toString(),
        type: "warning",
      });
      return;
    }
    const res = await setParentMeter(req);
    if (res.code === ResCode.SUCCESS) {
      // this.getList();
      this.batchSet = true;
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.BatchSetParentSuccess").toString(),
        type: "success",
      });
    }
  }
  // 批量设置表的用户
  public async batchSetBindUser() {
    let req: BatchBindUserReq = <BatchBindUserReq>{};
    let meterIDS: number[] = [];
    for (let item of this.selectItems) {
      if (!meterIDS.includes(item.id)) {
        meterIDS.push(item.id);
      }
    }
    req.batchMeterIDs = meterIDS;
    req.UserNO = this.batchBindUserID;
    if (!this.batchBindUserID) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("notification.PleaseSelectUser").toString(),
        type: "warning",
      });
      return;
    }
    const res = await batchBindUser(req);
    if (res.code === ResCode.SUCCESS) {
      // this.getList();
      this.batchSet = true;
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.BatchBindUserSuccess").toString(),
        type: "success",
      });
    }
  }

  // 批量设置表的缴费策略
  public async batchSetMeterCost(type) {
    let req: BatchBindMeterCostReq = <BatchBindMeterCostReq>{};
    let meterIDS: number[] = [];
    for (let item of this.selectItems) {
      if (!meterIDS.includes(item.id)) {
        meterIDS.push(item.id);
      }
    }
    req.type = type;
    if (!type) {
      req.meterCostName = this.batchBindMeterCostName;
    } else {
      req.meterCostName = this.batchBindNextCostName;
      req.date = this.batchBindNextCostDate;
      let date = new Date(this.batchBindNextCostDate);
      if (
        date.getDate() !== UserModule.companyPaymentDate ||
        date.getTime() < Date.now()
      ) {
        this.$notify({
          title: this.$t("common.warning").toString(),
          message: this.$t("notification.MeterCostDateError").toString(),
          type: "warning",
        });
        return;
      }
    }
    req.batchMeterIDs = meterIDS;

    if (!req.meterCostName) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("notification.PleaseSelectMeterCoust").toString(),
        type: "warning",
      });
      return;
    }
    const res = await batchBindMeterCost(req);
    if (res.code === ResCode.SUCCESS) {
      // this.getList();
      this.batchSet = true;
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.BatchBindMeterCostSuccess").toString(),
        type: "success",
      });
    }
  }

  private created() {
    this.adminID = UserModule.id;
    this.meterTypes = <string[]>(<any>this.$t("meterTypeArray"));
    this.disableStates = [
      { index: 0, state: this.$t("diableState.enabled").toString() },
      { index: 1, state: this.$t("diableState.disabled").toString() },
    ];
    this.queryMeterType();
    this.getList();
  }
}
